__turbopack_context__.v({
  "isNotValid": "tagsList-module-scss-module__s8FbFW__isNotValid",
  "removeTagIcon": "tagsList-module-scss-module__s8FbFW__removeTagIcon",
  "removeTagIconWrapper": "tagsList-module-scss-module__s8FbFW__removeTagIconWrapper",
  "tagWrapper": "tagsList-module-scss-module__s8FbFW__tagWrapper",
});
